var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"prefix",rawName:"v-prefix"}],staticClass:"#ad"},[(_vm.location && _vm.location.type)?_c(_vm.location.type,{tag:"component",attrs:{"name":_vm.name,"location":_vm.location,"campaigns":_vm.campaigns}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }